module.exports = __webpack_public_path__ + "static/media/biomarin.536d5c84.png";